import { PvaData } from "@inrange/api-clients";
import React from "react";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import { formatNumber, formatNumber2dp } from "../utils";

const PvSystemDescription: React.FC<{
  pvaData?: PvaData;
  pvaInstalledCapacity: number;
}> = ({ pvaData, pvaInstalledCapacity }) => {
  const totalMass = pvaData?.site_metrics?.total_mass?.toFixed(1) || "0";
  const netForce = pvaData?.site_metrics?.net_force || 0;
  const deadLoad = pvaData?.site_metrics?.dead_load || 0;
  const roofAllocation = pvaData?.site_metrics?.roof_allocation || 0;

  return (
    <>
      <Row className="d-flex flex-wrap align-items-end">
        <Col sm={4}>
          <Form.Group
            className="mb-3"
            controlId="pvDesign-pvaInstalledCapacity"
          >
            <Form.Label>Installed capacity (kWp)</Form.Label>
            <Form.Control disabled value={pvaInstalledCapacity.toFixed(3)} />
          </Form.Group>
        </Col>
        <Col sm={4}>
          <Form.Group className="mb-3" controlId="pvDesign-roofUtilisation">
            <Form.Label>Roof utilisation (%)</Form.Label>
            <Form.Control
              disabled
              value={formatNumber2dp(roofAllocation * 100)}
            />
          </Form.Group>
        </Col>
        <Col sm={4}>
          <Form.Group className="mb-3" controlId="pvDesign-panelCount">
            <Form.Label>Panel count</Form.Label>
            <Form.Control
              disabled
              value={
                pvaData?.site_metrics?.num_panels
                  ? formatNumber(pvaData.site_metrics?.num_panels, 0, 0)
                  : 0
              }
            />
          </Form.Group>
        </Col>
        <Col sm={4}>
          <Form.Group className="mb-3" controlId="pvDesign-totalMass">
            <Form.Label>Total panel mass (kg)</Form.Label>
            <Form.Control disabled value={totalMass} />
          </Form.Group>
        </Col>
        <Col sm={4}>
          <Form.Group className="mb-3" controlId="pvDesign-deadLoad">
            <Form.Label>
              Dead load (kN/m<sup>2</sup>)
            </Form.Label>
            <Form.Control disabled value={(deadLoad / 1000).toFixed(4)} />
          </Form.Group>
        </Col>
        <Col sm={4}>
          <Form.Group className="mb-3" controlId="pvDesign-netForce">
            <Form.Label>Net force (kN)</Form.Label>
            <Form.Control disabled value={(netForce / 1000).toFixed(4)} />
          </Form.Group>
        </Col>
      </Row>
    </>
  );
};

export default PvSystemDescription;
